var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c("div", { staticClass: "section" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclarationInfo")))
        ]),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              width: "500px"
            }
          },
          [
            _c(
              "el-form",
              {
                attrs: {
                  disabled: _vm.readonly,
                  "label-width": "60px",
                  "label-position": "left"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
                  },
                  [
                    _c("cargo-company-select", {
                      attrs: {
                        "method-params": {
                          customsBroker: true,
                          seaExport: true,
                          active: true
                        },
                        "default-value": _vm.job.customsBroker || ""
                      },
                      on: {
                        change: function(p) {
                          _vm.job.customsBroker = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Remarks") }
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 5 },
                      model: {
                        value: _vm.job.customsRemarks,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customsRemarks", $$v)
                        },
                        expression: "job.customsRemarks"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "section", staticStyle: { flex: "1" } }, [
        _c("div", { staticClass: "operations" }, [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "NewCustomsDeclaration",
                      type: "primary",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.addCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.NewCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "EditCustomsDeclaration",
                      type: "primary",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.editCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.EditCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "DeleteCustomsDeclaration",
                      type: "primary",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.delCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteCustomsDeclaration")))]
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticStyle: { "flex-grow": "1", "padding-top": "10px" } },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                "grid-options": _vm.gridOptions,
                "grid-params": _vm.gridParams,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  return (_vm.gridApi = params.api)
                }
              }
            })
          ],
          1
        )
      ]),
      _c("customs-info-dialog-ouj", {
        ref: "customsInfoDialogOuj",
        attrs: {
          visible: _vm.editDialog.visible,
          "selected-customs-info": _vm.selectedCustomsInfo,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("customs-info-interact-res-dialog", {
        ref: "customsInfoInteractResDialog",
        attrs: {
          visible: _vm.interactResDialog.visible,
          "customs-id": _vm.interactResDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.interactResDialog, "visible", $event)
          }
        }
      }),
      _c("file-history-dialog", {
        ref: "fileHistoryDialog",
        attrs: {
          visible: _vm.fileHistoryDialog.visible,
          "customs-id": _vm.fileHistoryDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileHistoryDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }